export default class Events {
	constructor() {
		this.$featuredEventContent = $('.js-featured-event-content');
		this.$list = $('.js-events-list');
		this.$listItem = this.$list.find('> li > span');
		this.$window = $(window);
		this.activeClass = 'js-is-active';
	}

	setEventContentHeight() {
		let maxHeight = 0;
		this.$featuredEventContent.each(function(){
			const $elm = $(this);

		   if ( $(this).height() > maxHeight ) { 
		   		maxHeight = $(this).height(); 
		   }

		});

		this.$featuredEventContent.parent().height(maxHeight);
	}

	onClick(event) {
		const $elm = $(event.currentTarget);
		const $ul = $elm.closest('li').find('ul').first();

		$elm.toggleClass(this.activeClass);
		$ul.slideToggle(300);

		return false;
	}

	setEventBindings() {
		this.setEventContentHeight();
		this.$window.on('resize', this.setEventContentHeight.bind(this));
		this.$listItem.on('click', this.onClick.bind(this));
	}

	init() {
		this.setEventBindings();
	}
}


// WEBPACK FOOTER //
// ./wp-content/themes/indiana811/source/scripts/components/Events.js